<template>
<v-card outlined rounded class="mt-4 mr-4">
    <v-card-text>
        <p class="text-h6 text--primary mb-12">
            {{title}}
        </p>
        <VueApexCharts type="donut" :options="memberNumbers.options" :series="memberNumbers.series"></VueApexCharts>
    </v-card-text>
</v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import formatData from "../utils/formatData";
export default {
    components: {
        VueApexCharts
    },
    data() {
        return {
            // title: 'Participants'
        }
    },
    created() {
        this.id = this.$route.params.id;
    },
    computed: {
        title(){
            return this.$attrs.memberNumbers.title;
        },  
        memberNumbers() {
            const chartInfo = {
                lastUpdate: this.$attrs.memberNumbers.lastUpdate,
                series: this.$attrs.memberNumbers.series,
                options: {
                    labels: this.$attrs.memberNumbers.labels,
                    colors: this.$attrs.memberNumbers.colors,
                    dataLabels: {
                        enabled: false,
                        formatter: function (val, opts) {
                            return opts.w.config.series[opts.seriesIndex]
                        },
                        fontSize: "14px",
                        style: {
                            fontSize: "14px"
                        }
                    },
                    fill: {
                        colors: this.$attrs.memberNumbers.colors,
                    },
                    legend: {
                        show: true,
                        fontSize: "14px",
                        color: 'red',
                        position: 'bottom',
                        horizontalAlign: 'center',
                        fontFamily: 'Helvetica, Arial',
                        fontWeight: 400,
                    },
                    plotOptions: {
                        pie: {
                            customScale: 1,
                            donut: {
                                size: '65%',
                                labels: {
                                    show: true,
                                    // name: {
                                    //     show: true,
                                    // },
                                    name: {
                                        show: true,
                                        // fontSize: '14px',
                                        // fontFamily: 'Helvetica, Arial, sans-serif',
                                        // fontWeight: 600,
                                        // color: undefined,
                                        offsetY: -2,
                                        formatter: function (val) {
                                            return val
                                        }
                                    },
                                    // value: {
                                    //     show: true,
                                    // },
                                    value: {
                                        show: true,
                                        fontSize: '14px',
                                        // fontFamily: 'Helvetica, Arial, sans-serif',
                                        // fontWeight: 400,
                                        // color: undefined,
                                        offsetY: 3,
                                        formatter: function (val) {
                                            return formatData('chart', val);
                                        }
                                    },
                                    // total: {
                                    //     show: true,
                                    //     label: 'Total',
                                    //     fontSize: '100%',
                                    //     formatter: function (w) {
                                    //         return w.globals.series.reduce((a, b) => {
                                    //             return a + b
                                    //         }, 0)
                                    //     }
                                    // },
                                    total: {
                                        show: true,
                                        showAlways: false,
                                        label: 'Total',
                                        // fontSize: '14px',
                                        // fontFamily: 'Helvetica, Arial, sans-serif',
                                        // fontWeight: 600,
                                        // color: '#373d3f',
                                        formatter: function (w) {
                                            let totalValue = w.globals.seriesTotals.reduce((a, b) => {
                                                return a + b
                                            }, 0);

                                            return formatData('chart', totalValue);
                                        }
                                    },
                                }
                            },
                        },
                    },
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: function(val) {
                                return formatData('chart', val);
                            },
                            // title: {
                            //     formatter: function (seriesName) {
                            //     return seriesName
                            //     }
                            // }
                        }
                    }
                }
            };
            return chartInfo;
        }
    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToGroupList(item, type) {
            if (type == "summary") {
                this.$router.push(`/challengesummary/${this.id}`);
            } else if (type == "verify") {
                this.$router.push(`/challengeverify/${this.id}`);
            } else {
                this.$router.push(`/challenge/${this.id}`);
            }
        },
        goToChallengeList() {
            this.$router.push(`/challenge`);
        }
    }
};
</script>
